<template>
  <div class="custom-content">
    <user-component
      :title="pageType===2?'重置密码':'免费 注 册'"
    >
      <div>
        <a-form ref="formRegister" :form="form" id="formRegister" style="text-align: left">
          <a-form-item>
            <a-input size="large" placeholder="11 位手机号"
                     v-decorator="['mobile', {rules: [{ required: true, message: '请输入正确的手机号', pattern: /^1[3456789]\d{9}$/ }, { validator: this.handlePhoneInput } ], validateTrigger: ['change', 'blur'] }]">
              <a-select slot="addonBefore" size="large" defaultValue="+86">
                <a-select-option value="+86">+86</a-select-option>
                <a-select-option value="+87">+87</a-select-option>
              </a-select>
            </a-input>
          </a-form-item>
          <a-row :gutter="16">
            <a-col class="gutter-row" :span="16">
              <a-form-item>
                <a-input size="large" type="text" placeholder="验证码"
                         v-decorator="['captcha', {rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur'}]">
                  <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }"/>
                </a-input>
              </a-form-item>
            </a-col>
            <a-col class="gutter-row" :span="8">
              <a-button
                class="getCaptcha"
                size="large"
                :disabled="state.smsSendBtn"
                @click.stop.prevent="getCaptcha"
                v-text="!state.smsSendBtn && '获取验证码'||(state.time+' s')"></a-button>
            </a-col>
          </a-row>

          <a-popover
            placement="rightTop"
            :trigger="['focus']"
            :getPopupContainer="(trigger) => trigger.parentElement"
            v-model="state.passwordLevelChecked">
            <template slot="content">
              <div :style="{ width: '240px' }">
                <div :class="['user-register', passwordLevelClass]">强度：<span>{{ passwordLevelName }}</span></div>
                <a-progress :percent="state.percent" :showInfo="false" :strokeColor="passwordLevelColor "/>
                <div style="margin-top: 10px;">
                  <span>请至少输入 6 个字符。请不要使用容易被猜到的密码。</span>
                </div>
              </div>
            </template>
            <a-form-item>
              <a-input
                size="large"
                type="password"
                @click="handlePasswordInputClick"
                autocomplete="false"
                :placeholder="pageType===2?'新密码6 - 16位密码，区分大小写':'至少6位密码，区分大小写' "
                v-decorator="['password', {rules: [{ required: true, message: '至少6位密码，区分大小写'}, { validator: this.handlePasswordLevel }], validateTrigger: ['change', 'blur']}]"
              ></a-input>
            </a-form-item>
          </a-popover>

          <a-form-item>
            <a-input
              size="large"
              type="password"
              autocomplete="false"
              placeholder="确认密码"
              v-decorator="['password2', {rules: [{ required: true, message: '至少6位密码，区分大小写' }, { validator: this.handlePasswordCheck }], validateTrigger: ['change', 'blur']}]"
            ></a-input>
          </a-form-item>
          <a-button
            size="large"
            style="width: 100%;margin-bottom: 6px"
            type="primary"
            @click.stop="submit"
            class="register-button"
            :loading="saveLoading"
            :disabled="saveLoading">{{ pageType === 2 ? '确 认 重 置' : '确 认 注 册' }}
          </a-button>
          <a-form-item>
            <a-checkbox
              :default-checked="false"
              v-model="agreement"
            > 已阅读并同意
            </a-checkbox>
            <a @click="showAgreementDialog=true">《用户使用协议》</a>
            <a style="float: right" @click="toLogin">使用已有帐户登录</a>
          </a-form-item>
        </a-form>
      </div>

    </user-component>
    <user-agreement-dialog :visible="showAgreementDialog" @close="showAgreementDialog=false"></user-agreement-dialog>
    <image-code-component
      :visible="visible"
      @close="visible=false"
      @confirm="onImageCodeConfirm"
    ></image-code-component>
  </div>
</template>

<script>
import { mixinDevice } from '@/utils/mixin.js'
import passwordMixins from '@/utils/mixins/passwordMixins'
import formMixin from '@/utils/mixins/formMixins'
import UserComponent from './components/UserComponent'
import UserAgreementDialog from '@/views/user/components/UserAgreementDialog'
import ImageCodeComponent from '@/views/user/components/ImageCodeComponent'
import userHelper from '@/utils/helper/userHelper'

export default {
  name: 'Register',
  components: {
    UserComponent,
    UserAgreementDialog,
    ImageCodeComponent
  },
  mixins: [mixinDevice, formMixin, passwordMixins],
  data() {
    return {
      showAgreementDialog: false,
      agreement: false,
      title: '',
      pageType: 1// 1是注册 2是重置密码
    }
  },
  activated() {
    this.pageType = this.$route.meta.type
    this.resetForm()
  },
  methods: {
    submit() {
      const { form: { validateFields }, state } = this
      validateFields({ force: true }, (err, values) => {
        if (!err) {
          state.passwordLevelChecked = false
          if (!this.agreement) {
            const operationName = this.pageType === 1 ? '注册' : '重置密码'
            this.$message.error(operationName + '前必须仔细阅读 并且同意用户使用协议')
            return
          }
          this.request(values)
        }
      })
    },
    toLogin() {
      this.backEvent()
    },

    getCaptcha(e) {
      e.preventDefault()
      const { form: { validateFields } } = this
      validateFields(['mobile'], { force: true },
        (err, values) => {
          if (!err) {
            this.visible = true
          }
        }
      )
    },
    onImageCodeConfirm(imageParams) {
      this.visible = false
      const mobile = this.form.getFieldProps('mobile').props.value
      this.requestCaptcha(mobile, imageParams)
    },
    request(values) {
      this.saveLoading = true
      const requestParams = {
        ...values,
        password: userHelper.getPasswordEncrypt(values.password),
        passwordStrength: this.passwordLevelName
      }
      delete requestParams.password2
      const path = this.pageType === 1 ? 'merchant/v2/operate/saveMerchant' : 'merchant/v2/operate/resetPwd'
      this.getHttpServices().getUserService().post(path, requestParams)
        .then(res => {
          const tips = this.pageType === 1 ? '注册成功' : '重置密码成功'
          this.$message.success(tips)
          setTimeout(() => this.backEvent(), 200)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.saveLoading = false)
    }
  }

}
</script>
<style lang="less">
.custom-content {
  margin: 0 auto; /*水平居中*/
}

.user-register {

  &.error {
    color: #ff0000;
  }

  &.warning {
    color: #ff7e05;
  }

  &.success {
    color: #52c41a;
  }

}

.user-layout-register {
  .ant-input-group-addon:first-child {
    background-color: #fff;
  }
}
</style>
<style lang="less" scoped>
.user-layout-register {

  & > h3 {
    font-size: 16px;
    margin-bottom: 20px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .register-button {
    width: 50%;
  }

  .login {
    float: right;
    line-height: 40px;
  }
}
</style>
